export default __webpack_public_path__ + "static/media/outline-right.1b5f7211.svg";